export const THIRD_PARTY_CARD_ENTERED_MESSAGE = "We are unable to check the balance of this gift card. Please follow the instructions above.";
